import React, { ReactElement, useEffect } from 'react';
import tickerVsMatchBg from '../../../../assets/svg/ticker_vs_match.svg';
import tickerVsReqBg from '../../../../assets/svg/ticker_vs_req01.svg';
import tickerCollabMatchBg from '../../../../assets/svg/ticker_collab_match.svg';
import tickerCollabReqBg from '../../../../assets/svg/ticker_collab_req01.svg';
import { ImageCustom } from '../../../../common/components/ImageCustom';
import './LiveMatchTicker.scss';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from '../../../../store/store';
import {
  LiveMatchKindType,
  LiveMatchStatusType,
  LiveMatchType,
} from '../../types/LiveMatchTypes';
import { useAcceptLiveMatchMutation } from '../../../../services/api/apiProvider';
import { RequestAcceptLiveMatch } from '../../../../services/api/models/request/requestLiveMatch';
import { updateLiveMatchData, updateWidthTicker } from '../../liveMatchSlice';
let timer: any;
const LiveMatchTicker = (): ReactElement => {
  const dispatch = useDispatch();
  const { liveMatchData, widthTicker } = useSelector(
    (state: AppState) => state.liveMatch,
  );
  const liveData = useSelector((state: AppState) => state.live.liveData);
  const [acceptLiveMatch] = useAcceptLiveMatchMutation();

  useEffect(() => {
    if (liveMatchData) {
      timer = setInterval(() => {
        if (widthTicker > 0) {
          dispatch(updateWidthTicker(widthTicker - 0.875));
        } else {
          clearInterval(timer);
          const element: HTMLElement | null =
            document.getElementById('ticker-live-match');
          if (element) {
            element.style.transform = 'translate(-100%, 0)';
          }
          if (
            (liveData?.id === liveMatchData.target.id &&
              liveMatchData.status === LiveMatchStatusType.PENDING) ||
            liveMatchData.status === LiveMatchStatusType.REJECT
          ) {
            const params: RequestAcceptLiveMatch = {
              id: liveMatchData.id,
              status: LiveMatchStatusType.REJECT,
            };
            acceptLiveMatch(params)
              .unwrap()
              .then(() => {
                dispatch(updateLiveMatchData(undefined));
              })
              .catch((error) => {
                console.log(error);
              });
          }
        }
      }, 250);
    }
    return () => {
      clearInterval(timer);
    };
  }, [liveMatchData, widthTicker]);

  const handleAcceptLiveMatch = async () => {
    if (liveMatchData) {
      const params: RequestAcceptLiveMatch = {
        id: liveMatchData.id,
        status: LiveMatchStatusType.ACCEPT,
      };
      await acceptLiveMatch(params).unwrap();
      const element: HTMLElement | null =
        document.getElementById('ticker-live-match');
      if (element) {
        element.style.transform = 'translate(-100%, 0)';
      }
      clearInterval(timer);
    }
  };

  if (liveMatchData) {
    const setupBackground = (
      kind: string,
      type: string,
    ): string | undefined => {
      if (kind === LiveMatchKindType.COLABO && type === LiveMatchType.RANDOM) {
        return tickerCollabMatchBg;
      }
      if (
        kind === LiveMatchKindType.COLABO &&
        type === LiveMatchType.SPECIFIED
      ) {
        return tickerCollabReqBg;
      }
      if (kind === LiveMatchKindType.VS && type === LiveMatchType.RANDOM) {
        return tickerVsMatchBg;
      }
      if (kind === LiveMatchKindType.VS && type === LiveMatchType.SPECIFIED) {
        return tickerVsReqBg;
      }
    };
    return (
      <div
        id="ticker-live-match"
        className="root-ticker-live-match"
        style={{
          backgroundImage: `url(${setupBackground(
            liveMatchData.kind,
            liveMatchData.type,
          )})`,
        }}
        onClick={handleAcceptLiveMatch}
      >
        <div className="ticker-live-match-item">
          <div className="ticker-live-match-item__avatar">
            <ImageCustom src={liveMatchData.live.user.picture.uri} />
          </div>
          <div className="ticker-live-match-item__info">
            <div className="ticker-live-match-item__user">
              {liveMatchData.live.user.loginId}
            </div>
            <div
              style={{
                width: `${widthTicker}px`,
                backgroundColor:
                  liveMatchData.kind === LiveMatchKindType.VS
                    ? '#FF2063'
                    : '#22cc00',
              }}
              className="ticker-live-match-item__time"
            ></div>
          </div>
        </div>
      </div>
    );
  } else return <></>;
};
export default LiveMatchTicker;
